import React from 'react';
import { InfluencerUploadInput } from './InfluencerUploadInput';
import { InfluencerUploadResult } from './InfluencerUploadResult';
import { AuthContext } from '../../Authentication/AuthContext';
import { HomeContext } from '../../Home/HomeContext';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { AxiosResponse } from 'axios';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';

export function InfluencerUpload() {
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);

    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [file, setFile] = React.useState<File | null>(null);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);

    async function uploadSpreadsheet(file: File) {
        setFile(file);

        const QuotaLimit : any = sessionStorage.getItem('ignoreQuotaLimit') ? sessionStorage.getItem('ignoreQuotaLimit') : 'false';
        const formData = new FormData();
        formData.append('documentData', JSON.stringify({ clientId: 92, clipperId: 8, ignoreQuotaLimit: QuotaLimit}));//ajustar clinet id e clipperId
        formData.append('file', file);

        setStatus(StatusUpload.LOADING);
        setResultUpload(InfluencerUploadResultInitial);
        InfluencerSpreadsheetService
            .postSpreadsheetFileInfluencer(authContext.login.user.id, formData)
            .then((res: AxiosResponse) => {
                sessionStorage.removeItem('ignoreQuotaLimit');
                setResultUpload({ ...res.data.object, status: StatusResult.SUCCESS });
                setStatus(StatusUpload.FINISH);
            }).catch((error) => {
                sessionStorage.removeItem('ignoreQuotaLimit');
                if (!error.data || error.data.status == 500) {
                    setResultUpload({ ...InfluencerUploadResultInitial, message: error.toString(), title: 'Exibir detalhes do problema', property: 'Repository', status: StatusResult.ERROR });
                    setStatus(StatusUpload.FINISH);
                } else {
                    const errorResponse: IErrorResponse = ErrorHelper(error);
                    setResultUpload({ ...InfluencerUploadResultInitial, message: errorResponse.message, title: 'Exibir detalhes do problema', property: error.data.errors[0].property, status: StatusResult.ERROR });
                    setStatus(StatusUpload.FINISH);
                }
            });
    }
    const handleStartClassification = () => {
        // homeContext.setSpreadsheetId(resultUpload.id);
        // homeContext.setPageLocation(PageLocation.INFLUENCER_HISTORY);
    };
    return (
        <div >
            {status === StatusUpload.INPUT && (
                <InfluencerUploadInput changeUpload={(file: File) => uploadSpreadsheet(file)} />)}
            {status === StatusUpload.LOADING && (
                <UploadLoading nameFile={file?.name ?? ''} />)}
            {status === StatusUpload.FINISH && (
                <InfluencerUploadResult
                    nameFile={file?.name ?? ''}
                    result={resultUpload}
                    hasHistoryButton={authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Classificação de influencers') !== -1}
                    onClickHistory={() => homeContext.setPageLocation(PageLocation.INFLUENCER_UPLOAD)}
                    onClickStartClassification={handleStartClassification}
                    onClickNewUpload={() => { setStatus(StatusUpload.INPUT); }} />)}
        </div>
    );
}